import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { OpAdminCheckoutService } from '../../services/op-admin-checkout.service';
import { OpAdminOrdersService } from '../../services/op-admin-orders.service';

@Component({
  selector: 'app-order-edit-address',
  templateUrl: './order-edit-address.component.html',
  styleUrls: ['./order-edit-address.component.css']
})
export class OrderEditAddressComponent implements OnInit {

  addressUpdateDialog: FormGroup;
  @Input() title: string;
  @Input() message: string;
  @Input() addressData: any;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;

  updateAddressForm: FormGroup;
  codeList: any = [];
  tosterConfig = {
    positionClass: "toast-top-center",
  };

  constructor(private activeModal: NgbActiveModal,
    private checkoutSrv: OpAdminCheckoutService,
    private ordersrv: OpAdminOrdersService,
    private toastr: ToastrService,) { }

  id: any;
  address: any;
  city: any;
  country: any;
  postCode: any

  ngOnInit() {
    this.getCountryList();
    this.buildCheckOutForm();
  }

  public dismiss() {
    this.activeModal.dismiss();
  }

  buildCheckOutForm() {
    this.updateAddressForm = new FormGroup({
      id: new FormControl(null, Validators.required),
      email: new FormControl(null, Validators.required),
      address: new FormControl(null, Validators.required),
      city: new FormControl(null, Validators.required),
      postCode: new FormControl(null, Validators.required),
      country: new FormControl(null, Validators.required),
    });
    this.patchCheckOutForm(this.addressData);
  }

  patchCheckOutForm(addressData) {
    this.updateAddressForm.patchValue({
      id: addressData.id,
      email: addressData.email,
      address: addressData.address,
      city: addressData.city,
      postCode: addressData.postCode,
      country: addressData.country,
    });
  }

  addressUpdate(formValues) {
    this.ordersrv.updateAddress(formValues).subscribe(
      (res: any) => {
        if (res.statusCode == 200) {
          this.activeModal.close(true)
        }
      });
  }

  getCountryList() {
    this.checkoutSrv.getCodeList().subscribe((res: any) => {
      this.codeList = res.data;
    });
  }

  public decline() {
    this.activeModal.close(false);
  }

}
